import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Router from './router/Router'
import { ProfileProvider } from './context/ProfileContext'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from './services/config/queryClient'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { WebSocketProvider } from './context/WebSocketContext'
import './App.css'

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <ProfileProvider>
          <WebSocketProvider>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
          </WebSocketProvider>
        </ProfileProvider>
        <ReactQueryDevtools
          client={queryClient}
          buttonPosition="bottom-right"
          position="bottom"
        />
      </QueryClientProvider>
    </div>
  )
}

export default App
